module.exports = __webpack_public_path__ + "static/media/img-22.be040066.jpg";